import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { AdminComponent } from './layout/admin/admin.component';
import { AuthComponent } from './layout/auth/auth.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from './shared/shared.module';
import { MenuItems } from './shared/menu-items/menu-items';
import { BreadcrumbsComponent } from './layout/admin/breadcrumbs/breadcrumbs.component';
import { Configuracion } from './app.configuracion';
import { CoreApiService, Interceptor, AuthService } from './core-api.service';
import { SimpleNotificationsModule } from 'angular2-notifications';
import { NotifyComponent } from './shared/notify/notify.component';
import { Global } from './shared/global/global';
import { ToastaModule } from 'ngx-toasta';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

@NgModule({
	declarations: [ AppComponent, AdminComponent, AuthComponent, BreadcrumbsComponent ],
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		AppRoutingModule,
		SharedModule,
		SimpleNotificationsModule.forRoot(),
		ToastaModule.forRoot()
	],
	providers: [
		MenuItems,
		Configuracion,
		CoreApiService,
		AuthService,
		NotifyComponent,
		Global,
		{
			provide: HTTP_INTERCEPTORS,
			useClass: Interceptor,
			multi: true
		}
	],
	bootstrap: [ AppComponent ]
})
export class AppModule {}
